import { Button } from "@material-ui/core";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import MainContainer from "../../components/MainContainer/MainContainer";
import { ProjectsForm } from "../../components/ProjectsForm";
import { ReassignForm } from "../../components/ReassignForm";
import { ProjectsTable } from "../../components/ProjectsTable";
import { ModalWindow } from "../../components/UI/ModalWindow/ModalWindow";
import {
  createProject,
  deleteProject,
  fetchProjects,
  updateProject
} from "../../store/actions/projectsActions";

import {
  reassignTasks,
} from "../../store/actions/tasksActions";

import classes from "./Projects.module.scss";

export const Projects = () => {
  const dispatch = useDispatch();
  const { projects } = useSelector(({ projects }) => projects);

  const [openModal, setOpenModal] = React.useState(false);
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const [openReassignModal, setOpenReassignModal] = React.useState(false);
  const [editedId, setEditedId] = React.useState(null);
  const [deletedId, setDeletedId] = React.useState(null);

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditedId(null);
  };

  const handleCloseReassignModal = () => {
    setOpenReassignModal(false);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleOpenReassignModal = () => {
    setOpenReassignModal(true);
  };

  const handleSubmit = ({ name, date, color, bitrix_group_id }) => {
    let start;

    if (typeof date === "string") {
      start = new Date(date);
    } else {
      start = date;
    }

    start.setTime(start.setHours(0, 0, 0, 0) + 3 * 60 * 60 * 1000);
    start = start.toISOString().split("T")[0];

    const projectData = { name, start, color, bitrix_group_id };

    if (!editedId) {
      dispatch(createProject(projectData));
    } else {
      dispatch(updateProject(editedId, projectData));
    }

    handleCloseModal();
  };

  const handleReassignSubmit = ({ old_employee_id, new_employee_id, only_previously_reassigned }) => {
    dispatch(reassignTasks({ old_employee_id, new_employee_id, only_previously_reassigned }));
    handleCloseReassignModal();
  };


  const handleEdit = (id) => {
    setEditedId(id);
    handleOpenModal();
  };

  const handleDelete = (id) => {
    setDeletedId(id);
    setOpenDeleteModal(true);
  };

  const handleDeleteProject = () => {
    dispatch(deleteProject(deletedId));
    setOpenDeleteModal(false);
  };

  React.useEffect(() => {
    dispatch(fetchProjects());
  }, []);

  return (
    <>
      <MainContainer>
      <div className={classes.projects}>
          <div className={classes.buttons_wrapper}>
            <div className={classes.add_wrapper}>
              <Button
                variant="contained"
                classes={{
                  root: classes.add_btn
                }}
                onClick={handleOpenModal}
              >
                <span className={classes.btn_text}>Добавить</span>
              </Button>
            </div>
            <div className={classes.export_wrapper}>
              <Button
                variant="contained"
                classes={{
                  root: classes.export_btn
                }}
                onClick={handleOpenReassignModal}
              >
                <span className={classes.btn_text}>Переназначить задачи</span>
              </Button>
            </div>
          </div>
          {projects?.length > 0 ? (
            <section className={classes.tableWrapper}>
              <div className={classes.title}>Проекты</div>
              <ProjectsTable
                projects={projects}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
              />
            </section>
          ) : (
            <div className={classes.no_rows}>
              <div className={classes.text}>
                Чтобы создать проект, нажмите кнопку “Добавить”
              </div>
            </div>
          )}
        </div>
      </MainContainer>
      <ModalWindow
        isOpen={openModal}
        handleClose={handleCloseModal}
        title={editedId ? "Изменить проект" : "Создать проект"}
      >
        <ProjectsForm
          onCancel={handleCloseModal}
          onSubmit={handleSubmit}
          editedId={editedId}
        />
      </ModalWindow>
      <ModalWindow
        isOpen={openReassignModal}
        handleClose={handleCloseReassignModal}
        title={"Переназначить задачи"}
      >
        <ReassignForm
          onCancel={handleCloseReassignModal}
          onSubmit={handleReassignSubmit}
        />
      </ModalWindow>
      <ModalWindow
        isOpen={openDeleteModal}
        handleClose={() => setOpenDeleteModal(false)}
        title={"Удалить проект"}
      >
        <p className={classes.block_info}>
          Вы уверены, что хотите удалить проект?
        </p>
        <div className={classes.button_wrapper}>
          <Button
            classes={{
              root: classes.cancel_btn
            }}
            onClick={() => setOpenDeleteModal(false)}
            variant="contained"
            disableElevation
          >
            Отменить
          </Button>
          <Button
            classes={{
              root: classes.submit_btn
            }}
            onClick={handleDeleteProject}
            variant="contained"
            color="primary"
            type="submit"
            disableElevation
          >
            Удалить
          </Button>
        </div>
      </ModalWindow>
    </>
  );
};
